// Polite "temporarily unavailable" notice (ServiceNotice) and the WhatsApp fallback of the checkout.
export default {
  notice: {
    "title": "Servicio temporalmente no disponible",
    "message": "En este momento, {{what}} no está funcionando. Le pedimos, por favor, que se comunique con nosotros por WhatsApp para confirmar su reserva — nuestro equipo responde rápidamente.",
    "whatsapp": "Confirmar por WhatsApp",
    "retry": "Intentar de nuevo",
    "hint": "Le pedimos disculpas por las molestias.",
    "what": {
      "payment": "el pago en línea",
      "booking": "la reserva en línea de esta fecha",
      "seats": "la reserva en línea de este paseo",
      "tour": "esta página del paseo",
      "page": "esta página",
      "generic": "este servicio"
    },
    "fallback": {
      "title": "Confirme su reserva por WhatsApp",
      "preflight": "En este momento, el pago en línea con Pix no está disponible. Para no perder su lugar, confirme la reserva directamente con nuestro equipo por WhatsApp — le enviamos todos los datos.",
      "failed": "No fue posible completar el pago en línea en este momento. Para asegurar su lugar, confirme la reserva directamente con nuestro equipo por WhatsApp — le enviamos todos los datos.",
      "point1": "Paseo, fecha y participantes ya van en el mensaje",
      "point2": "Nuestro equipo confirma con usted la disponibilidad y el pago",
      "point3": "Su reserva queda registrada con un código",
      "cta": "Confirmar reserva por WhatsApp",
      "autoOpening_one": "Abriendo WhatsApp en {{count}} segundo…",
      "autoOpening_other": "Abriendo WhatsApp en {{count}} segundos…",
      "stay": "Prefiero quedarme aquí",
      "autoCancelled": "Apertura automática cancelada. Use el botón de abajo cuando quiera.",
      "retryOnline": "Intentar el pago en línea de nuevo"
    }
  },
};
